import { createApi } from '@reduxjs/toolkit/query/react';

import { formCustomRTKQueryError } from '@mint-lib/rtk-query-client';

import { CREATE_NEW_IO, GET_NEW_IO } from '../constants/EndpointConstants.js';
import type { GetIOInfo, IOId, NewIOType } from '../types/insertionOrder.js';
import type { BaseQueryError } from '../types/shared.js';
import { axiosBaseQuery } from './apiSlice.js';

export const insertionOrderApi = createApi({
  reducerPath: 'insertionOrderApi',
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    getInsertionOrderInfo: builder.query<IOId[], GetIOInfo>({
      query: ({ buyingPlanId, buyingPlanItemId }) => ({
        url: `${GET_NEW_IO}?buying_plan_id=${buyingPlanId}&buying_plan_item_id=${buyingPlanItemId}`,
      }),
      transformErrorResponse: (
        err: BaseQueryError<{ message: string; code?: string }>,
      ) => {
        return formCustomRTKQueryError({
          snackbarOptions: { skipAppearance: true },
          code: err.data.code,
        });
      },
    }),
    createInsertionOrder: builder.mutation<{ ioEntryId: number }, NewIOType>({
      query: (data) => ({
        url: CREATE_NEW_IO,
        method: 'POST',
        data,
      }),
      transformErrorResponse: (
        err: BaseQueryError<{ message: string; code?: string }>,
      ) => {
        return formCustomRTKQueryError({
          snackbarOptions: { skipAppearance: true },
          code: err.data.code,
        });
      },
    }),
  }),
});

export const {
  useGetInsertionOrderInfoQuery,
  useLazyGetInsertionOrderInfoQuery,
  useCreateInsertionOrderMutation,
} = insertionOrderApi;
